import React, { Component } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
// import { Carousel } from "react-responsive-carousel";
import { Carousel } from "antd";
// import profile from "../../../assets/images/profile.png";
import postService from "../../../services/httpService";
import networkList from "../../../constants/networkList";
import { queue } from "jquery";
import Slider from "react-slick";
import { Fragment } from "react";
import hospitalIcon from "../../../assets/images/Bitmap.png";
import "./../../../index.scss";

const $ = require("jquery");

class OpdTvDisplay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      QueueList: [],
      currentIndex: 0,
      // tableData: null,
      blinkArray: [],
      renderType: "",
      isExistsInBlinkArray: [],
      message: ""
    };
  }
  componentDidMount() {
  
    this.getDoctorDetails();
    this.speechText("init");
    // this.renderBodydata("init");
    this.interval1 = setInterval(this.getDoctorDetails.bind(this), 8000);

    // this.getDoctorDetails();
    // this.interval1 = setInterval(this.nextBtn, 9000);
  }

  componentDidUpdate(prevProps, prevState) {
    $(".custom-container").css({
      "overflow-x": "hidden",
      "overflow-y": "hidden",
    });
    if (prevState.QueueList !== this.state.QueueList) {
      this.renderBodydata("init");
    }
    if (prevState.blinkArray !== this.state.blinkArray) {
      this.speechText("second");
    }
    if (prevState.currentIndex !== this.state.currentIndex) {
      this.renderBodydata("second");
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval1);
    $("footer").css({ position: "relative", top: "unset" });
  
    // this.state = {
    //   tableData: [],
    // };
  }

  getDoctorDetails() {
    const { slug } = this.props.match.params;
    let { getOPDTVScreensWithNoAuth } = networkList;
    postService(getOPDTVScreensWithNoAuth, "POST", {
      data: { tv_display_id: slug },
    }).then((res) => {
      if (res.status) {
        res.data && res.data.length ? this.setState({ QueueList: res.data, }) : this.setState({ message: "Doctors are yet to start the consultation", });
      }else { 
        this.setState({ message: "Error! Something Went Wrong!", });
      }
    });
  }

  noDoctorsMapped() {
    return (
      // <div className="container-fluid p-0">
      //   {/* <div class="container my-5 text-center">
      //     <img alt="" src={hospitalIcon} width="50%" height="30%" />
      //   </div> */}
      //   <div class="container text-center nodoctortvscreen">
      //     <div className="row h-100 w-100 tv-bg">
      //       <div className="col-xl-4 col-lg-4 col-4 message">
      //         <p className="blink_tvscreen" style={{fontSize :"30px", fontWeight:"bold"}}>Doctors are yet to start the consultation.</p>
      //       </div>
      //     </div>
      //   </div>
      // </div>
      <div className="container-fluid nodoctortvscreen p-0 m-0">
          <div className="row h-100 tv-bg m-0">
            <div className="col message text-center">
              <p className="blink_tvscreen">{this.state.message}</p>
            </div>
          </div>
      </div>
    )
  }

  renderBodydata(type) {
    const { slug } = this.props.match.params;
    let { getOPDTVScreensWithNoAuth } = networkList;
    let { QueueList, blinkArray, currentIndex, isExistsInBlinkArray } =
      this.state;
    let blink = [];
    let exists_patient = [];
    let filtered = [];
    // postService(getOPDTVScreensWithNoAuth, "POST", {
    //   data: { tv_display_id: slug },
    // }).then((res) => {
    //   if (res.status) {
    //     this.setState({
    //       QueueList: res.data,
    //     });
    this.setState({
      blinkArray: [],
    });
    if (QueueList && QueueList.length) {
      QueueList[currentIndex] &&
        QueueList[currentIndex].patients &&
        QueueList[currentIndex].patients.length &&
        QueueList[currentIndex].patients.map((patient, key) => {
          exists_patient =
            isExistsInBlinkArray && isExistsInBlinkArray.length
              ? isExistsInBlinkArray.filter((ele) => ele.id === patient.id)
              : [];  
          if (patient.status === "4") {
            if (exists_patient.length === 0) {
              QueueList[currentIndex].patients[key]["blink_sound"] =
                "show_blink";
              blink.push(QueueList[currentIndex]["patients"][key]);
            }
          } else {
            let exists_index = isExistsInBlinkArray.indexOf(exists_patient[0]);
            let removepatient_isExistsInBlinkArray =
              exists_patient &&
              exists_index > -1 &&
              isExistsInBlinkArray.splice(exists_index, 1);
          
          }
        });
      this.setState((state) => ({
        blinkArray: blink ? blink : [],
        renderType: type,
        isExistsInBlinkArray:
          blink && blink.length
            ? [...isExistsInBlinkArray, ...blink]
            : isExistsInBlinkArray,
      }));
    }
  }
  // sleep function
  sleep = (milliseconds) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  };
  // call sleep by async
  delayed = async (ms) => {
    await this.sleep(ms);
  };
  // call the speechtext each object sync,3times with delay
  speechText = async (type) => {
    // console.log(type)
    let { blinkArray } = this.state;
    if (blinkArray && blinkArray.length) {
      let i = blinkArray.length;
      for (const data of blinkArray) {
        let key = i;
        // await this.delayed(1000);

        var audio = new Audio("/assets/announcement.mp3");
        audio.play();

        // blink
        await this.callToken(data, key);

        // delay
        // await this.delayed(5000);
      }
    }
  };
  callToken = async (data, key) => {
    setTimeout(async () => {
      try {
        // var element = document.getElementById("a" + data.id);
        // // var element = document.getElementsByClassName("col my-auto order-1");
        // element.classList.add("blink_me");
        // var element2 = document.getElementById("c" + data.id);
        // element2.classList.add("blink_me");
        // var element3 = document.getElementById("d" + data.id);
        // element3.classList.add("blink_me");
        // await this.delayed(4000);
        // // remove blink css
        // var element = document.getElementById("a" + data.id);
        // // var element = document.getElementById("col my-auto order-1");
        // element.classList.remove("blink_me");
        // var element2 = document.getElementById("c" + data.id);
        // element2.classList.remove("blink_me");
        // var element3 = document.getElementById("d" + data.id);
        // element3.classList.remove("blink_me");

        const collection = document.getElementsByClassName(`a${data.id}`);
        let len = collection.length ? collection.length : 0;
        for (let i = 0; i < len; i++) {
          collection[i].classList.add("blink_me");
        }
        await this.delayed(4000);
        for (let i = 0; i < len; i++) {
          collection[i].classList.remove("blink_me");
        }
      } catch (error) {
        console.log(error);
      }
      return Promise.resolve(true);
    }, 10);
  };
  // prevBtn = () => {
  //   const { currentIndex, QueueList } = this.state;
  //   QueueList.length &&
  //     this.setState({
  //       currentIndex:
  //         currentIndex === 0 ? QueueList.length - 1 : currentIndex - 1,
  //     });
  // };
  // nextBtn = () => {
  //   const { currentIndex, QueueList } = this.state;
  //   currentIndex === QueueList.length - 1 && this.getDoctorDetails();
  //   QueueList.length &&
  //     this.setState({
  //       blinkArray: [],
  //       currentIndex:
  //         currentIndex === QueueList.length - 1 ? 0 : currentIndex + 1,
  //     });
  // };
  doctorDetailsDiv = (queue) => {
    // const { tableData } = this.state;
    // let details = tableData && tableData;
    let { doctor_profile_url } = networkList;
    let details = queue && queue;
    return (
      <div>
        {/* <img alt="" src={profile} className="qdoctorImg" /> */}
        <img
          alt=""
          src={
            details && details.profile_pic
              ? doctor_profile_url + details.profile_pic
              : "/assets/images/newProfile.png"
          }
          className="qdoctorImg1"
        />
        
        <span className="qdoctorName">
          {details && details.doctor_name ? details.doctor_name : ''}
        </span>
        <span className="qdoctorProf">
          {details && details.specialization_code
            ? details.specialization_code
            :  ''}
        </span>
        {/* {details && details.experience ? (
          <span className="qdoctorExp">
            Experience:
            {details.experience + " Years"}
          </span>
        ) : (
          <div className="row"></div>
        )} */}
        <div className="row qroom_status pb-5">
          <span className="qdoctorRoom mb-5">
            {" "}
            <span className="qdoctor-text-style-1 mb-5">
              {details && details.room_number ? details.room_number : ''}
            </span>
          </span>
        </div>
        <span className="qdoctorName">
          {details && details.doctor_name ? "" : '\u00A0'}
        </span>
        <span className="qdoctorProf">
          {details && details.specialization_code
            ?""
            :  '\u00A0'}
        </span>
        <span className="qdoctor-text-style-1 mb-5">
              {details && details.room_number ? "" : '\u00A0'}
            </span>
        {/* <div style={{color:"#FFF0AB"}}>{details && details.doctor_break_status=='1'?(<p>{details && details.doctor_name ?( <p>{details.doctor_name} is in break</p>) : "Doctor is in break"}</p>):(<p></p>)} </div>
         */}
         <div className="doctorBreakText">{details && details.doctor_break_status && details.doctor_break_status=='1'?(<p> On Break</p>):(<p></p>)} </div>
        
        {/* <span className="row qdoctorTimings">Timings:</span>
        <div className="row qdocTimings">
          <span className="qdoctorTime">
            {details ? "10:00AM-02:00PM" : ""}
          </span>
          <span className="qdoctorTime">
            {details ? "03:00PM-10:00PM" : ""}
          </span>
        </div> */}
      </div>
    );
  };
  patientDetailsDiv = (patients) => {
    // const { tableData } = this.state;
    // let patients = tableData && tableData.patients;
    return (
      <>
        <div className="card">
          <table>
            <thead>
              <tr className="row head-row">
                <th className="col ">Patient Name</th>
                <th className="col ">UID</th>
                <th className="col ">Patient Status</th>
              </tr>
            </thead>
            <tbody>
              {patients && patients.length
                ? patients.map((patient) => (
                    <tr className={patient.is_investigation === 'YES' ? "row tv-row bg-thistle" : (patient.current_workflow_stage_id === "4") ? "row tv-row bg-bluish-grey" : "row tv-row bg-grey" }>
                      <td
                        className={`col my-auto order-1 a${patient.id}`}
                        id={"a" + patient.id}
                        // style={{'border':'1px solid #ae8ca6'}}
                        // style={{'border':'1px solid #ae8ca6', 'border-colo1':'#ae8ca6', 'border-width':'thin'}}
                      >
                        {patient.name}
                        <span className="text-danger review">{patient.is_investigation==='YES'&&' (INV)' }</span>
                      </td>
                      <td
                        className={`col my-auto order-1 a${patient.id}`}
                        id={"c" + patient.id}
                        // style={{'border':'1px solid #ae8ca6'}}
                        // style={{'border':'1px solid #ae8ca6', 'border-colo1':'#ae8ca6', 'border-width':'thin'}}
                      >
                        {patient.umr}
                      </td>
                      <td
                        className={`col my-auto order-1 a${patient.id}`}
                        id={"d" + patient.id}
                        // style={{'border':'1px solid #ae8ca6'}}
                        // style={{'border':'1px solid #ae8ca6', 'border-colo1':'#ae8ca6', 'border-width':'thin'}}
                      >
                        {patient.status === "3"
                          ? "In Queue"
                          : patient.status === "4" && "Checked-in"}
                      </td>
                    </tr>
                  ))
                : ""}
            </tbody>
          </table>
        </div>
      </>
    );
  };
  setCurrentIndex = (currentItem) => {
    // this.state.currentIndex = currentItem;
    this.setState({
      currentIndex: currentItem,
    });
  };

  render() {
    const { QueueList } = this.state;
    const testimonial_settings = {
      dots: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 2000,
      slidesToShow: 1,
      slidesToScroll: 1,
      pauseOnHover: true,
      arrows: false,
      // fade: true,
      // cssEase: 'linear',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };
    // const myElement = document.getElementById("demo");
    // this.state.testIndex = myElement;

    // const collection = document.querySelector(".carousel-item.active");
    // this.state.testIndex = collection;
    return (
      <Fragment>
        {QueueList.length
          ? <div className="tv-counter-data">
              <div className="counter-card">
                <div className="reports-details counter-details">
                  {/* <div className="row">
                    <div className="col-lg-4 col-md-4 doctorsDetailsDiv m-0">
                      {this.doctorDetailsDiv()}
                    </div>
                    <div className="col-lg-8 col-md-8 patientQ p-0 pl-1 tv-screen-bg">
                      {this.patientDetailsDiv()}
                    </div>
                  </div> */}
                  {/* react-slick */}
                  {/* <Slider {...testimonial_settings}>
                    {QueueList.length &&
                      QueueList.map((queue, i) => {
                        return (
                          <div className="row">
                            <div className="col-lg-4 col-md-4 doctorsDetailsDiv m-0">
                              {this.doctorDetailsDiv(queue)}
                            </div>
                            <div className="col-lg-8 col-md-8 patientQ p-0 pl-1 tv-screen-bg">
                              {this.patientDetailsDiv(queue.patients)}
                            </div>
                          </div>
                        );
                      })}
                  </Slider> */}
                  {/* react-responsive-slider */}
                  {/* <Carousel
                    showArrows={false}
                    autoPlay={true}
                    interval={7000}
                    infiniteLoop={true}
                    stopOnHover={false}
                    showThumbs={false}
                    statusFormatter={(currentItem, total) =>
                      this.setCurrentIndex(currentItem)
                    }
                  >
                    {QueueList.length &&
                      QueueList.map((queue, i) => (
                        <div style={{ display: "flex" }}>
                          <div className="col-lg-4 col-md-4 doctorsDetailsDiv m-0">
                            {this.doctorDetailsDiv(queue)}
                          </div>
                          <div className="col-lg-8 col-md-8 patientQ p-0 pl-1 tv-screen-bg">
                            {this.patientDetailsDiv(queue.patients)}
                          </div>
                        </div>
                      ))}
                  </Carousel> */}
                  {/* bootstrap */}
                  {/* <div
                    id="demo"
                    class="carousel slide"
                    data-ride="carousel"
                    data-interval="5000"
                    data-pause={false}
                  >
                    <div class="carousel-inner">
                      {QueueList.length
                        ? QueueList.map((queue, i) => (
                            <div
                              className={`carousel-item ${i === 0 && "active"}`}
                              id={i}
                            >
                              <div className="row">
                                <div className="col-lg-4 col-md-4 doctorsDetailsDiv m-0">
                                  {this.doctorDetailsDiv(queue)}
                                </div>
                                <div className="col-lg-8 col-md-8 patientQ p-0 pl-1 tv-screen-bg">
                                  {this.patientDetailsDiv(queue.patients)}
                                </div>
                              </div>
                            </div>
                          ))
                        : ""}
                    </div>
                  </div> */}
                  {/* ant design */}
                  <Carousel
                    autoplay
                    pauseOnHover={false}
                    afterChange={(currentIndex) => this.setCurrentIndex(currentIndex)}
                    key={QueueList.length.toString()}
                    autoplaySpeed={7000}
                    dots={false}
                  >
                    {/* {QueueList.length ?  */}
                    { QueueList.map((queue, i) => (
                        <div
                          // className={`carousel-item ${i === 0 && "active"}`}
                          className="carousel-item active"
                          id={i}
                        >
                          <div className="row m-0">
                            <div className="col-lg-4 col-md-4 doctorsDetailsDiv m-0">
                              {this.doctorDetailsDiv(queue)}
                            </div>
                            <div className="col-lg-8 col-md-8 patientQ p-0 pl-1 tv-screen-bg">
                              {this.patientDetailsDiv(queue.patients)}
                            </div>
                          </div>
                        </div>
                      ))
                    }
                  </Carousel>
                </div>
              </div>
            </div>
          : this.noDoctorsMapped()
        } 
      </Fragment>
    );
  }
}
export default OpdTvDisplay;
